import { http } from '../../axios';
import { shopPrefix } from '../../../config';

const url = `${shopPrefix}/v1/subscription-management/renewals`;

export const updateRenewals = () => {
    return http.post<void>(url);
};
